import styled from 'styled-components'

export const Iframe = styled.iframe`
  border: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100 - 63px);
  width: 100%;
`
